import React from "react";
import { Drawer } from "antd";
import PropTypes from "prop-types";
import BookmarksSectionMessages from "../MessageLogic/BookmarksSectionMessages";

export default function MessagesDrawer({ visible, onClose }) {
  return (
    <Drawer
      title="Mis mensajes"
      placement="right"
      onClose={onClose}
      open={visible}
      width={320}
      bodyStyle={{ padding: 16 }}
    >
      <BookmarksSectionMessages onClose={onClose} />
    </Drawer>
  );
}

MessagesDrawer.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
